module.exports = __webpack_public_path__ + "img/Requests-logo.5c89b076.svg";